import React from "react"
import { StaticQuery, graphql } from "gatsby"

const MembershipsQuery = ({ slug = '', render: Render }) => (
  <StaticQuery
    query={graphql`
      query {
        allContentfulMembership {
          edges {
            node {
              id
              slug
              title
              baseCost
              pricingMethod
              hideFromForms
              hideFromPages
              image {
                resize(width:1800) {
                  src
                }
              }
              shortDescription {
                childMarkdownRemark {
                  html
                }
              }
              longDescription {
                childMarkdownRemark {
                  html
                }
              }
              banner {
                headlineContent {
                  json
                }
                sublineContent {
                  json
                }
                theme
              }
              contentModules {
                __typename    
                ...on ContentfulSectionImageWithContent {
                  id
                }
                ...on ContentfulSectionLocations {
                  id
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const membership = data.allContentfulMembership.edges.find(({ node }) => (
        node.slug === slug
      ))

      return <Render data={membership.node} />
    }}
  />
)

export default MembershipsQuery
